module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b5iIS"))).then(() => parcelRequire('4ti9D'));